import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MaterialModule } from "src/material-Module";

import { FullCalendarModule } from "@fullcalendar/angular";
import {
  RecaptchaV3Module,
  RECAPTCHA_V3_SITE_KEY,
  ReCaptchaV3Service,
} from "ng-recaptcha";
import { ToastrModule } from "ngx-toastr";
import { NgSelectModule } from "@ng-select/ng-select";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { TokenInterceptoprService } from "./Services/token-interceptopr.service";
import { LandingPageComponent } from "./Module/Navigation/landing-page/landing-page.component";
import { UserDashboardComponent } from "./Module/Users/user-dashboard/user-dashboard.component";
import { LoginComponent } from "./Module/Main/login/login.component";
import { RegsiterComponent } from "./Module/Main/regsiter/regsiter.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "./Shared/shared/shared.module";
import { ForgotComponent } from "./Module/Main/forgot-password/forgot.component";
import { ResetComponent } from "./Module/Main/reset-password/reset.component";
import { getInTouchComponent } from "./Module/Navigation/get-in-touch/get-in-touch.component";
import { PartnerComponent } from "./Module/Navigation/our-partner/partner.component";
import { CurrencyPipe, NgOptimizedImage } from "@angular/common";
import { FaqComponent } from "./Module/Navigation/faq/faq.component";
import { CdkAccordionModule } from "@angular/cdk/accordion";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatNativeDateModule } from "@angular/material/core";
import {
  FontAwesomeModule,
} from "@fortawesome/angular-fontawesome";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MatMenuModule } from "@angular/material/menu";
import { environment } from "src/environments/environment";
import { ErrorInterceptor } from "./Services/error-interceptor.service";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import { SeperatorDirective } from "./directives/seperator.directive";
import { VerificationLandingComponent } from "./Module/Navigation/vefification/verification-landing/verification-landing.component";
import { VerificationResultComponent } from "./Module/Navigation/vefification/verification-result/verification-result.component";
import { ForTestingComponent } from "./Module/Navigation/for-testing/for-testing.component";
import { ClickElsewhereDirective } from "./Shared/click-else-where-directive.directive";
import { NgxPrintModule } from "ngx-print";
import { ScriptLoaderService } from "./Services/script-loader.service";
import { ScriptService } from "./Services/script-service.service";
import { DemandNoticePaymentComponent } from "./Module/demand-notice-payment/demand-notice-payment.component";
import { AsinPaymentPageComponent } from "./Module/Main/asin-payment-page/asin-payment-page.component";
import { PublicPaymentModalComponent } from "./Module/Main/public-payment-modal/public-payment-modal.component";
import { PublicPaymentSuccessComponent } from "./Module/Main/public-payment-success/public-payment-success.component";
import { TaxClearanceComponent } from "./Module/Navigation/tax-clearance/tax-clearance.component";
import { SupportResourcesComponent } from "./Module/Navigation/support-resources/support-resources/support-resources.component";
import { LearnMoreModalComponent } from "./Module/Navigation/learn-more-modal/learn-more-modal.component";
import { LottieComponent, provideLottieOptions } from "ngx-lottie";
import player from "lottie-web";
import { SearchMdaServicesComponent } from "./Module/Main/search-mda-services/search-mda-services.component";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { CreateMdaServiceComponent } from "./Module/Main/create-mda-service/create-mda-service.component";
import { SearchMdaBillHistoryComponent } from "./Module/Main/search-mda-bill-history/search-mda-bill-history.component";
import { GenerateMdaBillHistoryComponent } from "./Module/Main/generate-mda-bill-history/generate-mda-bill-history.component";
import { ViewMdaBillDetailsComponent } from "./Module/Main/view-mda-bill-details/view-mda-bill-details.component";
import { FirstTimePasswordChangeComponent } from "./Module/Main/first-time-password-change/first-time-password-change.component";
import { PrintReceiptComponent } from "./Module/Navigation/payments-history/print-receipt/print-receipt.component";
import { CreateAsinLandingComponent } from "./Module/Navigation/create-asin/create-asin-landing/create-asin-landing.component";
import { CreateAsinHeaderComponent } from "./Module/Navigation/create-asin/create-asin-header/create-asin-header.component";
import { IndividualDataComponent } from "./Module/Navigation/create-asin/individual-asin/individual-data/individual-data.component";
import { VerifyCodeComponent } from "./Module/Navigation/create-asin/individual-asin/verify-code/verify-code.component";
import { SuccessScreenComponent } from "./Module/Navigation/create-asin/individual-asin/success-screen/success-screen.component";
import { BasicInformationComponent } from "./Module/Navigation/create-asin/individual-asin/basic-information/basic-information.component";
import { CaptureImageComponent } from "./Module/Navigation/create-asin/individual-asin/capture-image/capture-image.component";
import { CorporateDataComponent } from "./Module/Navigation/create-asin/corporate-asin/corporate-data/corporate-data.component";
import { VerifyMethodComponent } from "./Module/Navigation/create-asin/corporate-asin/verify-method/verify-method.component";
import { VerificationCodeComponent } from "./Module/Navigation/create-asin/corporate-asin/verification-code/verification-code.component";
import { CorporateInformationComponent } from "./Module/Navigation/create-asin/corporate-asin/corporate-information/corporate-information.component";
import { SuccessContinueComponent } from "./Module/Navigation/create-asin/corporate-asin/success-continue/success-continue.component";
import { IndividualLandingComponent } from "./Module/Navigation/create-asin/individual-asin/individual-landing/individual-landing.component";
import { OnlyNumberDirective } from "./Module/Navigation/create-asin/only-number.directive";
import { AutoFocusNextDirective } from "./Module/Navigation/create-asin/auto-focus-next.directive";
import { CorporateLandingComponent } from "./Module/Navigation/create-asin/corporate-asin/corporate-landing/corporate-landing.component";
import { InformationPreviewComponent } from "./Module/Navigation/create-asin/corporate-asin/information-preview/information-preview.component";
import { AsinGenerationComponent } from "./Module/Navigation/create-asin/individual-asin/asin-generation/asin-generation.component";
import { IndividualPreviewComponent } from "./Module/Navigation/create-asin/individual-asin/individual-preview/individual-preview.component";
import { PublicAsinSearchComponent } from "./Module/Main/public-asin-search/public-asin-search.component";
import { MatExpansionModule } from "@angular/material/expansion";
import { CookieService } from "ngx-cookie-service";
import { ClickOutsideDirective } from "./directives/click-outside.directive";
import { CreateBillsPublicComponent } from "./Module/Main/mda/create-bills-public/create-bills-public.component";
import { InformalLandingComponent } from "./Module/Navigation/create-asin/corporate-asin/informal-landing/informal-landing.component";
import { InformalAsinFormComponent } from "./Module/Navigation/create-asin/corporate-asin/informal-landing/informal-asin-form/informal-asin-form.component";
import { FormatTimePipe } from './Shared/format-time.pipe';
import { InvoiceValidationModalComponent } from './Module/Main/invoice-validation-modal/invoice-validation-modal.component';
import { InvoicePaymentPage } from "./Module/Main/invoice-payment-page/invoice-payment-page.component";
import { ChangePasswordComponent } from './Module/Main/change-password/change-password.component';
import { ExecutiveSideNavComponent } from "./Module/executive/navigation/executive-side-nav/executive-side-nav.component";
import { ExecutiveTopNavComponent } from "./Module/executive/navigation/executive-top-nav/executive-top-nav.component";
import {InfiniteScrollModule} from "ngx-infinite-scroll";
import { TaxpayerRecordUpdateNotificationComponent } from "./Shared/shared/taxpayer-record-update-notification/taxpayer-record-update-notification.component";
import {NgxDaterangepickerMd} from "ngx-daterangepicker-material";
import { ViewCustomMdaDetailsComponent } from './Module/Main/view-custom-mda-details/view-custom-mda-details.component';
import { ReconcileMdaBilsManualComponent } from './Module/Main/reconcile-mda-bils-manual/reconcile-mda-bils-manual.component';
import { NotificationComponent } from './notification/notification.component';
import { FormPageComponent } from "./Module/Main/form-page/form-page.component";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import { TamaLandingComponent } from './Module/Navigation/tama-landing/tama-landing.component';
import { TaasLandingComponent } from "./Module/Navigation/taas-landing/taas-landing.component";
import { TaasHeroArtComponent } from "./Module/Navigation/taas-landing/taas-hero-art/taas-hero-art.component";
import { UserBillsComponent } from "./Module/Navigation/user-bills/user-bills.component";
import { WarningModalComponent } from './Shared/modals/warning-modal/warning-modal.component';
import { VaidsWarningModalComponent } from './Shared/modals/warning-modal/vaids-warning-modal/vaids-warning-modal.component';
import { VaidsCarouselSlideComponent } from './Module/Navigation/landing-page/components/vaids-carousel-slide/vaids-carousel-slide.component';
import { PropertyPaymentPageComponent } from './Module/Main/property-payment-page/property-payment-page.component';


@NgModule({
  declarations: [
    AppComponent,
    LandingPageComponent,
    UserDashboardComponent,
    LoginComponent,
    RegsiterComponent,
    ForgotComponent,
    ResetComponent,
    getInTouchComponent,
    PartnerComponent,
    FaqComponent,
    SeperatorDirective,
    VerificationLandingComponent,
    VerificationResultComponent,
    ForTestingComponent,
    ClickElsewhereDirective,
    DemandNoticePaymentComponent,
    AsinPaymentPageComponent,
    PublicPaymentModalComponent,
    PublicPaymentSuccessComponent,
    TaxClearanceComponent,
    SupportResourcesComponent,
    LearnMoreModalComponent,
    SearchMdaServicesComponent,
    CreateMdaServiceComponent,
    SearchMdaBillHistoryComponent,
    GenerateMdaBillHistoryComponent,
    ViewMdaBillDetailsComponent,
    FirstTimePasswordChangeComponent,
    PrintReceiptComponent,
    CreateAsinLandingComponent,
    CreateAsinHeaderComponent,
    IndividualDataComponent,
    VerifyCodeComponent,
    SuccessScreenComponent,
    BasicInformationComponent,
    CaptureImageComponent,
    CorporateDataComponent,
    VerifyMethodComponent,
    VerificationCodeComponent,
    CorporateInformationComponent,
    SuccessContinueComponent,
    IndividualLandingComponent,
    OnlyNumberDirective,
    AutoFocusNextDirective,
    CorporateLandingComponent,
    InformalLandingComponent,
    InformalAsinFormComponent,
    InformationPreviewComponent,
    AsinGenerationComponent,
    IndividualPreviewComponent,
    PublicAsinSearchComponent,
    ClickOutsideDirective,
    CreateBillsPublicComponent,
    FormatTimePipe,
    InvoiceValidationModalComponent,
    InvoicePaymentPage,
    ChangePasswordComponent,
    ExecutiveSideNavComponent,
    ExecutiveTopNavComponent,
    TaxpayerRecordUpdateNotificationComponent,
    ViewCustomMdaDetailsComponent,
    ReconcileMdaBilsManualComponent,
    NotificationComponent,
    FormPageComponent,
    TamaLandingComponent,
    TaasLandingComponent,
    TaasHeroArtComponent,
    UserBillsComponent,
    WarningModalComponent,
    VaidsWarningModalComponent,
    VaidsCarouselSlideComponent,
    PropertyPaymentPageComponent,
  ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MaterialModule,
        SharedModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        NgOptimizedImage,
        CdkAccordionModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatDialogModule,
        FontAwesomeModule,
        FullCalendarModule,
        NgbModule,
        MatMenuModule,
        RecaptchaV3Module,
        ToastrModule.forRoot({
            timeOut: 5000,
            extendedTimeOut: 1000,
            positionClass: "toast-top-center",
            preventDuplicates: true,
            // progressBar: true,
            easeTime: 300,
            closeButton: true,
            easing: "ease-in",
        }),
        NgSelectModule,
        NgxPrintModule,
        LottieComponent,
        BsDatepickerModule,
        NgxIntlTelInputModule,
        MatExpansionModule,
        InfiniteScrollModule,
        NgxDaterangepickerMd,
        TooltipModule
    ],
  providers: [
    CurrencyPipe,
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptcha.siteKey,
      deps: [ReCaptchaV3Service],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptoprService,
      multi: true,
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: ErrorInterceptor, multi: true
    },
      // {
      //     provide: HTTP_INTERCEPTORS,
      //     useClass: EncryptionInterceptor,
      //     multi: true
      // },
    CookieService,
    ScriptService,
    ScriptLoaderService,
    provideLottieOptions({
      player: () => player,
    }),
  ],
  bootstrap: [AppComponent],

  exports: [
    MaterialModule,
    SeperatorDirective,
    ClickElsewhereDirective,
    ClickOutsideDirective,
  ],
})
export class AppModule {
}
